require('./color.scss');


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/color/color.js
// module id = 106
// module chunks = 0 1 2 3 9 16 19 20 26